const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const REQUIRED_CONTACT = ['company', 'contactPerson', 'street', 'zip', 'city'];

export const minStartDate = () => new Date(Date.now() + 14 * 864e5).toISOString().slice(0, 10);
export const todayPlus = (days) => new Date(Date.now() + days * 864e5).toISOString().slice(0, 10);
export const APPT_TIMES = ['vormittags (9–12 Uhr)', 'mittags (12–14 Uhr)', 'nachmittags (14–17 Uhr)', 'abends (17–19 Uhr)'];

export function validateStep(order, step, minDate = minStartDate()) {
  const e = {};
  if (step === 1 && order.kind !== 'beratung' && !order.selectionId) {
    e.selection = 'Bitte wählen Sie ein Paket oder eine Kampagne.';
  }
  if (step === 3) {
    if (order.kind === 'beratung') {
      if (!order.apptDate1) e.apptDate1 = 'Bitte einen Wunschtermin wählen.';
      else if (order.apptDate1 < todayPlus(2)) e.apptDate1 = 'Bitte einen Termin mindestens zwei Tage im Voraus wählen.';
      if (!order.apptTime1) e.apptTime1 = 'Bitte eine Tageszeit wählen.';
    } else {
      if (!order.startDate) e.startDate = 'Bitte wählen Sie einen Starttermin.';
      else if (order.startDate < minDate) e.startDate = 'Der Start ist frühestens zehn Werktage nach Auftragsbestätigung möglich.';
      if (!order.branche.trim()) e.branche = 'Bitte geben Sie Ihre Branche an.';
    }
  }
  if (step === 4) {
    REQUIRED_CONTACT.forEach((k) => { if (!order[k].trim()) e[k] = 'Pflichtfeld'; });
    if (!order.email.trim()) e.email = 'Pflichtfeld';
    else if (!EMAIL_RE.test(order.email)) e.email = 'Bitte eine gültige E-Mail-Adresse eingeben.';
  }
  if (step === 5) {
    if (!order.consentTerms) e.consentTerms = 'Bitte bestätigen Sie die Auftragsbedingungen.';
    if (!order.consentAuthority) e.consentAuthority = 'Bitte bestätigen Sie Ihre Berechtigung.';
    const hasSig = order.signatureMode === 'draw' ? !!order.signatureData : !!order.typedName.trim();
    if (!hasSig) e.signature = 'Bitte unterschreiben Sie – gezeichnet oder getippt.';
  }
  return e;
}

export const validateAll = (order, minDate) =>
  [1, 3, 4, 5].reduce((acc, s) => ({ ...acc, ...validateStep(order, s, minDate) }), {});

export const toPayload = (order) => ({
  ...order,
  signatureData: order.signatureMode === 'draw' ? order.signatureData : null,
  typedName: order.signatureMode === 'type' ? order.typedName : null,
});
